import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  Autocomplete,
  InputLabel,
  FormControl,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useState, useEffect } from "react";
import Header from "../../../components/Header";
import { accountsmanagement, clientManagementUrl } from "../../../config";
import {
  allCorporateClients,
  allIndividualClients,
  allPayeeTypes,
  allSuppliers,
} from "../../../data/Axios/queries";
import {
  fetchDataEngine,
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";

const base_url = accountsmanagement.uri;
const client_base_url = clientManagementUrl.uri;

const clientTypeOptions = [
  { id: 1, name: "Individual Clients" },
  { id: 2, name: "Corporate Clients" },
];
const VoucherLineForm = (props) => {
  const {
    isEditing = false,
    data = {},
    onClose,
    refetchData,
    onAction,
    paymentVoucherId,
  } = props;

  const initialValues = {
    id: data?.id || null,
    clientTypeId: data?.clientTypeId || null,
    paymentVoucherId: data?.paymentVoucherId || paymentVoucherId || null,
    lineNumber: data?.lineNumber || null,
    payeeTypeId: data?.payeeTypeId || null,
    payeeId: data?.payeeId || null,
    referenceId: data?.referenceId || null,
    referenceNumber: data?.referenceNumber || "",
    accountTypeId: data?.accountTypeId || null,
    accountId: data?.accountId || null,
    description: data?.description || "",
    amount: data?.amount || 0,
    withholdingTaxId: data?.withholdingTaxId || null,
    withholdingTaxRate: data?.withholdingTaxRate || 0,
    withholdingTaxAmount: data?.withholdingTaxAmount || 0,
    vatId: data?.vatId || null,
    vatAmount: data?.vatAmount || 0,
    netLineAmount: data?.netLineAmount || 0,
    isAdvance: data?.isAdvance || false,
    isPosted: data?.isPosted || false,
    allocationStatus: data?.allocationStatus || "Pending",
    allocatedAmount: data?.allocatedAmount || 0,
    isActive: data?.isActive !== undefined ? data?.isActive : 1,
  };

  const decodedToken = JSON.parse(localStorage.getItem("decodedToken") || "{}");
  const userId = parseInt(decodedToken.Id) || null;
  const companyid = parseInt(decodedToken.CompanyId) || null;
  const pvdata = JSON.parse(localStorage.getItem("PVData"));
  const [payees, setPayees] = useState([]);
  const [purchaseInvoice, setPurchaseInvoice] = useState([]);
  const [vatTypes, setVatTypes] = useState([]);
  const [accountTypes, setAccountTypes] = useState([]);
  const [payeeTypes, setPayeeTypes] = useState([]);
  const [glAccounts, setGlAccounts] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [payeeTypeId, setPayeeTypeId] = useState(data?.payeeTypeId || null);
  const [showPurchaseInvoice, setShowPurchaseInvoice] = useState(false);
  const [showClientType, setShowClientType] = useState(false);
  // Filter payees based on payee type

  const filterPayees = (
    payeeTypeId,
    suppliers,
    customers,
    glAccounts,
    employees
  ) => {
    const typeId = parseInt(payeeTypeId);
    setPayeeTypeId(typeId);
    setShowClientType(false);
    switch (typeId) {
      case 1: // Supplier
        return suppliers.map((s) => ({
          id: s.id,
          name: s.supplierName,
          payeeTypeId: 1,
        }));
      case 2:
        setShowClientType(true);
        return customers.map((c) => ({
          id: c.id,
          name: c.name,
          payeeTypeId: 2,
        }));
        case 3: // Employee
        return employees.map((e) => ({
          id: e.id,
          name: e.fullName || `${e.firstName} ${e.lastName}`,
          payeeTypeId: 4,
        }));
      case 4: // GL Account
        return glAccounts.map((gl) => ({
          id: gl.id,
          name: gl.accountName,
          payeeTypeId: 3,
        }));
      
      default:
        return [];
    }
  };

  const handlePayeeChange = async (newValue) => {
    if (payeeTypeId == 1) {
      const invoices = await fetchDataEngine(
        "allPurchaseInvoiceByColumnValues",
        "purchaseInvoices",
        { supplierId: newValue.id },
        ["id", "invoiceNumber", "supplierName"],
        base_url
      );
      if (invoices !== null) {
        setPurchaseInvoice(invoices || []);
        setShowPurchaseInvoice(true);
      }
    } else {
      setPurchaseInvoice([]);
      setShowPurchaseInvoice(false);
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const supllyers = await graphqlQuery(allSuppliers, base_url);
        if (supllyers !== null) {
          setSuppliers(supllyers);
        }
        const PayeeTypes = await graphqlQuery(allPayeeTypes, base_url);
        if (PayeeTypes !== null) {
          setPayeeTypes(PayeeTypes);
        }

        // Fetch GL Accounts
        const glAccountData = await fetchDataEngine(
          "allAccountsByColumnValues",
          "accounts",
          {
        
            identifierId: companyid,
            identifierType: 7,
            accountType: "Expenses",
          },
          ["id", "accountName"],
          base_url
        );
        if (glAccountData !== null) {
           setGlAccounts(glAccountData || []);
        }
       
  
      } catch (error) {
        console.error("Error fetching form data:", error);
      }
    };
    fetchData();
  }, []);

  // Set payees based on fetched data and props.data
  useEffect(() => {
    if (data?.payeeTypeId) {
      const filteredPayees = filterPayees(
        data.payeeTypeId,
        suppliers,
        customers,
        glAccounts,
        employees
      );
      setPayees(filteredPayees);
    }
  }, [data, suppliers, customers, glAccounts, employees]);

  const validationSchema = yup.object().shape({
    payeeTypeId: yup.string().required("Payee Type is required"),
    payeeId: yup.string().required("Payee is required"),

    amount: yup
      .number()
      .required("Amount is required")
      .positive("Amount must be positive"),
    description: yup.string().required("Description is required"),
  });

  const isNonMobile = useMediaQuery("(min-width:600px)");
  const handleClientTypeChange = async (newValue) => {
    if (newValue.id == 1) {
      const individualCustomers = await fetchDataEngine(
        "allIndividualClients",
        "clientModel",
        { isActive: 1 },
        ["id", "firstName", "lastName"],
        client_base_url
      );
      const individualCustomersFormatted = individualCustomers.map((c) => ({
        id: c.id,
        name: c.firstName + " " + c.lastName,
      }));
      setPayees(individualCustomersFormatted);
    } else {
      const corporateCustomers = await fetchDataEngine(
        "allCorporateClients",
        "clientModel",
        { isActive: 1 },
        ["id", "companyName"],
        client_base_url
      );
      const corporateCustomersFormatted = corporateCustomers.map((c) => ({
        id: c.id,
        name: c.companyName,
      }));
      setPayees(corporateCustomersFormatted);
    }
  };
  // Calculate amounts based on inputs
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const {
        payeeTypeId,
        payeeId,
        referenceId,
        clientTypeId,
        description,
        amount,
      } = values;

      const baseMutationData = {
        paymentVoucherId: parseInt(pvdata.id),
        payeeTypeId: parseInt(payeeTypeId),
        payeeId: payeeId ? parseInt(payeeId) : null,
        referenceId: referenceId ? parseInt(referenceId) : null,
        clientTypeId: clientTypeId ? parseInt(clientTypeId) : null,
        description,
        amount: parseFloat(amount),
      };

      const mutationData = isEditing
        ? {
            ...baseMutationData,
            id: data?.id,
            isActive: data?.isActive ? data?.isActive : 1,
          }
        : { ...baseMutationData };

      const response = await generateAndExecuteMutation(
        isEditing ? "updatePaymentVoucherLine" : "createPaymentVoucherLine",
        mutationData,
        isEditing ? "updatePaymentVoucherLine" : "newPaymentVoucherLine",
        base_url
      );

      if (response) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Payment Voucher Line ${
            isEditing ? "updated" : "created"
          } successfully.`,
        });

        if (onAction) {
          onAction();
        } else if (refetchData) {
          refetchData();
        }
        onClose();
      }
    } catch (error) {
      console.error("Submission error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box m="20px">
      <Header
        title={
          isEditing ? "Edit Payment Voucher Line" : "Add Payment Voucher Line"
        }
        subtitle={
          isEditing ? "Edit an Existing Line Item" : "Add a New Line Item"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize={true}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": {
                  gridColumn: isNonMobile ? undefined : "span 4",
                },
              }}
            >
              {/* Payee Type Dropdown */}
              <FormControl
                fullWidth
                variant="filled"
                sx={{ gridColumn: "span 2" }}
              >
                <InputLabel>Payee Type *</InputLabel>
                <Select
                  name="payeeTypeId"
                  value={values.payeeTypeId || ""}
                  onChange={(e) => {
                    const newTypeId = e.target.value;
                    setFieldValue("payeeTypeId", newTypeId);
                    setFieldValue("payeeId", null);
                    setPayees(
                      filterPayees(
                        newTypeId,
                        suppliers,
                        customers,
                        glAccounts,
                        employees
                      )
                    );
                  }}
                  onBlur={handleBlur}
                  error={touched.payeeTypeId && !!errors.payeeTypeId}
                >
                  {payeeTypes.map((type) => (
                    <MenuItem key={type.id} value={type.id}>
                      {type.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* ClientType */}
              {showClientType && (
                <Autocomplete
                  fullWidth
                  options={clientTypeOptions}
                  getOptionLabel={(option) => option.name || ""}
                  // ✅ Correct: find the selected payee from Formik's current value
                  value={
                    clientTypeOptions.find(
                      (p) => p.id === values.clientTypeId
                    ) || null
                  }
                  onChange={(e, newValue) => {
                    setFieldValue("clientTypeId", newValue?.id || null);
                    handleClientTypeChange(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="filled"
                      label="Client Type"
                      error={touched.clientTypeId && !!errors.clientTypeId}
                      helperText={touched.clientTypeId && errors.clientTypeId}
                    />
                  )}
                  sx={{ gridColumn: "span 2" }}
                />
              )}
              {/* Payee Dropdown */}
              <Autocomplete
                fullWidth
                options={payees}
                getOptionLabel={(option) => option.name || ""}
                // ✅ Correct: find the selected payee from Formik's current value
                value={payees.find((p) => p.id === values.payeeId) || null}
                onChange={(e, newValue) => {
                  setFieldValue("payeeId", newValue?.id || null);
                  handlePayeeChange(newValue);
                }}
                disabled={!values.payeeTypeId}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="filled"
                    label="Payee *"
                    error={touched.payeeId && !!errors.payeeId}
                    helperText={touched.payeeId && errors.payeeId}
                  />
                )}
                sx={{ gridColumn: "span 2" }}
              />

              {showPurchaseInvoice && (
                <Autocomplete
                  fullWidth
                  options={purchaseInvoice}
                  getOptionLabel={(option) =>
                    option.invoiceNumber + option.supplierName || ""
                  }
                  value={
                    purchaseInvoice.find((p) => p.id === values.referenceId) ||
                    null
                  }
                  onChange={(e, newValue) => {
                    setFieldValue("referenceId", newValue?.id || null);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="filled"
                      label="Purchase Invoice "
                      error={touched.referenceId && !!errors.referenceId}
                      helperText={touched.referenceId && errors.referenceId}
                    />
                  )}
                  sx={{ gridColumn: "span 2" }}
                />
              )}

              {/* Description */}
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Description *"
                value={values.description}
                name="description"
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.description && !!errors.description}
                helperText={touched.description && errors.description}
                multiline
                rows={2}
                sx={{ gridColumn: "span 4" }}
              />

              {/* Amount */}
              <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Amount *"
                onBlur={handleBlur}
                onChange={(e) => {
                  handleChange(e);
                }}
                value={values.amount || ""}
                name="amount"
                error={touched.amount && !!errors.amount}
                helperText={touched.amount && errors.amount}
                InputProps={{ inputProps: { min: 0, step: 0.01 } }}
                sx={{ gridColumn: "span 2" }}
              />
            </Box>

            <Box display="flex" justifyContent="end" mt="20px" gap={2}>
              <Button
                variant="outlined"
                onClick={onClose}
                disabled={isSubmitting}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting
                  ? "Submitting..."
                  : isEditing
                  ? "Update Line"
                  : "Add Line"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default VoucherLineForm;
